import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div style={{
    backgroundColor: '#000000',
    margin: 0,
    padding: 0,
    minHeight: '100vh',
    minWidth: '100vw',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  }}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </div>
);
